let gallerySlideshowSwiper = new Swiper('.gallery-display-as-slideshow .swiper', {
	slidesPerView: 'auto',
	spaceBetween:  16,
	speed:         500,
	autoHeight:    true,
	pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},
	/*loop:          true,
	autoplay:      {
		delay:                3000,
		stopOnLastSlide:      false
	},*/
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});

let gallerySwiper = new Swiper('figure .swiper', {
	slidesPerView: 1,
	spaceBetween:  0,
	loop:          true,
	navigation:    {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});


let collezioniSlideshowSwiper = new Swiper('.collezioni-slideshow .swiper', {
	slidesPerView:'auto',
	spaceBetween:  12,
	slidesOffsetBefore: 24,
	slidesOffsetAfter: 24,
	breakpoints: {
		992: {
			slidesOffsetBefore: 0,
		}
	}
});